import { Record, OrderedMap } from "immutable";
import Section from "./section";

const defaults = {
    _id: undefined,
    active: false,
    brand: undefined,
    view_name: "",
    schema_id: undefined,
    key: "",
    sections: OrderedMap,
    associations: undefined,
    name: undefined,
};

class ViewRecord extends Record(defaults) {
    constructor(args = {}) {
        super(
            Object.assign({}, args, {
                _id: args._id || undefined,
                sections: OrderedMap(
                    args.sections &&
                        args.sections.map((val) => {
                            return [val.key, new Section(val)];
                        })
                ),
            })
        );
    }

    getColumnWidths() {
        let totalWidth = 0;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const view = this;
        const details = view.sections.get("details");
        if (details) {
            details.elements.forEach((element) => {
                totalWidth += element.getWidth();
            });
        }
        return totalWidth;
    }
}

export default ViewRecord;
